export function matchesPersistedFile(file, record) {
  if (!file || !record) return false;
  return (
    file.name === record.fileName
    && file.size === record.fileSize
    && file.lastModified === record.lastModified
  );
}
